import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import type { ApiError } from './types';

const axiosInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL ?? '/api',
  withCredentials: true, // HttpOnly Cookie 자동 전송
  timeout: 15_000,
  headers: { 'Content-Type': 'application/json' },
});

axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => config,
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const apiError: ApiError = {
      status: error.response?.status ?? 0,
      message: '알 수 없는 오류가 발생했습니다.',
    };

    if (!error.response) {
      apiError.message = '서버에 연결할 수 없습니다.';
      return Promise.reject(apiError);
    }

    const serverMessage = (error.response.data as { message?: string })
      ?.message;

    switch (error.response.status) {
      case 401:
        apiError.message = '로그인이 필요합니다.';
        if (typeof window !== 'undefined') {
          window.location.href = '/login';
        }
        break;
      case 403:
        apiError.message = '접근 권한이 없습니다.';
        break;
      case 404:
        apiError.message = '리소스를 찾을 수 없습니다.';
        break;
      case 502:
      case 503:
        apiError.message =
          '서버가 응답하지 않습니다. 잠시 후 다시 시도해주세요.';
        break;
      default:
        apiError.message = serverMessage ?? apiError.message;
    }

    return Promise.reject(apiError);
  }
);

export default axiosInstance;
